import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    LineChart,
    Line,
} from "recharts";

function EmptyChart({ height = 220 }) {
    return (
        <div className="d-flex align-items-center justify-content-center text-muted" style={{ height, fontSize: 13 }}>
            No data available
        </div>
    );
}

export function SubjectMarksBarChart({ subjects }) {
    if (!subjects || subjects.length === 0) return <EmptyChart />;
    return (
        <div style={{ width: "100%", height: Math.max(200, subjects.length * 40) }}>
            <ResponsiveContainer>
                <BarChart data={subjects} layout="vertical" margin={{ left: 20, right: 30 }}>
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                    <XAxis type="number" tick={{ fontSize: 11 }} />
                    <YAxis type="category" dataKey="subjectName" tick={{ fontSize: 11 }} width={100} />
                    <Tooltip shared={false} />
                    <Bar dataKey="averageMarks" name="Average Marks" fill="#2563eb" radius={[0, 4, 4, 0]} label={{ position: "right", fontSize: 10.5, fill: "#2563eb", fontWeight: 700 }} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export function SubjectAccuracyRadar({ subjects }) {
    if (!subjects || subjects.length < 3) return <EmptyChart />;
    return (
        <div style={{ width: "100%", height: 260 }}>
            <ResponsiveContainer>
                <RadarChart data={subjects} outerRadius={90}>
                    <PolarGrid />
                    <PolarAngleAxis dataKey="subjectName" tick={{ fontSize: 11 }} />
                    <PolarRadiusAxis tick={{ fontSize: 10 }} domain={[0, 100]} />
                    <Radar name="Accuracy" dataKey="averageAccuracy" stroke="#7c3aed" fill="#7c3aed" fillOpacity={0.4} />
                    <Tooltip shared={false} />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
}

export function SubjectRightWrongChart({ subjects }) {
    if (!subjects || subjects.length === 0) return <EmptyChart />;
    return (
        <div style={{ width: "100%", height: 240 }}>
            <ResponsiveContainer>
                <BarChart data={subjects}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="subjectName" tick={{ fontSize: 10 }} interval={0} angle={-25} textAnchor="end" height={50} />
                    <YAxis tick={{ fontSize: 11 }} />
                    <Tooltip shared={false} />
                    <Legend />
                    <Bar dataKey="rightAnswers" name="Right" stackId="rw" fill="#16a34a" />
                    <Bar dataKey="wrongAnswers" name="Wrong" stackId="rw" fill="#dc2626" radius={[4, 4, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}

export function RankDistributionChart({ data }) {
    if (!data || data.length === 0) return <EmptyChart />;
    return (
        <div style={{ width: "100%", height: 240 }}>
            <ResponsiveContainer>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" hide tick={{ fontSize: 10 }} />
                    <YAxis reversed tick={{ fontSize: 11 }} />
                    <Tooltip shared={false} />
                    <Legend />
                    <Line type="monotone" dataKey="examRank" name="Exam Rank" stroke="#2563eb" dot={false} />
                    <Line type="monotone" dataKey="overallRank" name="Overall Rank" stroke="#d97706" dot={false} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}

export default SubjectMarksBarChart;
